import { Box, Button, Grid, Switch, TextField } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useCallback, useEffect, useState } from 'react'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'
import { AlertPopup, handdleOpenAlert } from '../../components/StyleComponent'

export default function Email({ update }) {
    const [form, setForm] = useState({
        host: '',
        port: '',
        username: '',
        password: '',
        encryption: false,
    })
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')
    const [openAlert, setOpenAlert] = useState(false)
    const [loading, setLoading] = useState({ save: false, send: false })
    const [showPassword, setShowPassword] = useState(false)

    const handleAlert = (message, status) => {
        handdleOpenAlert(setOpenAlert, setMessage, message, status)
    }

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev)
    }

    const getData = useCallback(async () => {
        try {
            const response = await axiosInstance.get(urlConfig.smtp)
            const data = response.data.message
            setForm({ ...data, password: atob(data.password) })
        } catch (error) {}
    }, [])

    const onSubmit = async () => {
        setLoading({ save: true })
        try {
            await axiosInstance.put(urlConfig.smtp, form)
            handleAlert('SMTP updated successfully', 'success')
        } catch (error) {
            handleAlert('Failed to update SMTP', 'error')
        } finally {
            setLoading({ save: false })
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        onSubmit()
    }

    const testSend = async (event) => {
        event.preventDefault()
        setLoading({ send: true })
        try {
            await axiosInstance.post(`${urlConfig.smtp}/smtp-test`, {
                email: email,
            })

            handleAlert('Email sent successfully.', 'success')
        } catch (error) {
            handleAlert('Failed to send Email', 'error')
        } finally {
            setLoading({ send: false })
        }
    }
    useEffect(() => {
        getData()
    }, [getData])

    const validateSMTPAddress = (address) => {
        // ตรวจสอบว่าเป็น IP Address (IPv4)
        const ipRegex =
            /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/
        // ตรวจสอบว่าเป็น Hostname ที่ถูกต้อง
        const hostnameRegex = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
        return ipRegex.test(address) || hostnameRegex.test(address)
    }

    return (
        <div>
            <div>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} p={3}>
                        <Grid item xs={12}>
                            <Box sx={{ fontWeight: 'bold', fontSize: '20px' }}>
                                SMTP Server
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <TextField
                                disabled={!update}
                                fullWidth
                                type='text'
                                error={
                                    !!form.host &&
                                    !validateSMTPAddress(form.host)
                                }
                                helperText={
                                    !!form.host &&
                                    !validateSMTPAddress(form.host) &&
                                    'Invalid SMTP address'
                                }
                                label='SMTP Server Address'
                                name='host'
                                size='small'
                                value={form.host || ' '}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        host: e.target.value,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                disabled={!update}
                                type='number'
                                fullWidth
                                label='Port'
                                name='port'
                                size='small'
                                value={form.port}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        port: e.target.value,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                disabled={!update}
                                fullWidth
                                label='Username'
                                name='username'
                                size='small'
                                value={form.username}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        username: e.target.value,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ position: 'relative' }}>
                                <TextField
                                    disabled={!update}
                                    fullWidth
                                    label='Password'
                                    name='password'
                                    size='small'
                                    type={showPassword ? 'text' : 'password'}
                                    value={form.password || ''}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            password: e.target.value,
                                        })
                                    }
                                />
                                <Button
                                    onClick={togglePasswordVisibility}
                                    sx={{
                                        color: 'grey',
                                        position: 'absolute',
                                        top: '50%',
                                        right: '10px',
                                        transform: 'translateY(-50%)',
                                        minWidth: 'auto',
                                    }}
                                >
                                    {showPassword ? (
                                        <VisibilityOff />
                                    ) : (
                                        <Visibility />
                                    )}
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Box>
                                    <label
                                        style={{
                                            fontWeight: 'bold',
                                            fontSize: '14px',
                                        }}
                                    >
                                        SSL/TLS
                                    </label>
                                    <Switch
                                        disabled={!update}
                                        color='success'
                                        checked={!!form.encryption}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                encryption: e.target.checked,
                                            })
                                        }
                                    />
                                </Box>
                                <Button
                                    variant='contained'
                                    color='buttonSave'
                                    type='submit'
                                    size='small'
                                    sx={{ width: '100px' }}
                                    disabled={
                                        !update ||
                                        loading.save ||
                                        (!validateSMTPAddress(form.host) &&
                                            !!form.host)
                                    }
                                >
                                    Save
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
                <form onSubmit={testSend}>
                    <Grid container spacing={2} p={3}>
                        <Grid item xs={12}>
                            <Box sx={{ fontWeight: 'bold', fontSize: '20px' }}>
                                Test
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label='Email'
                                name='email'
                                type='email'
                                size='small'
                                value={email}
                                required
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Box sx={{ fontSize: '14px' }} mt={1}>
                                <span style={{ fontWeight: 'bold' }}>
                                    Note:
                                </span>{' '}
                                Settings must be saved before you send a test
                                email
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Button
                                    variant='contained'
                                    color='success'
                                    size='small'
                                    sx={{ width: '100px' }}
                                    type='submit'
                                    disabled={loading.send}
                                >
                                    SEND
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <AlertPopup
                message={message}
                open={openAlert}
                setOpen={setOpenAlert}
            />
        </div>
    )
}
